import { render, staticRenderFns } from "./VetClaimUpdate.vue?vue&type=template&id=0c29d8b0&"
import script from "./VetClaimUpdate.vue?vue&type=script&lang=js&"
export * from "./VetClaimUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports